<div *ngIf="infoApprenant" class="class-margin">
  <div uk-grid>
    <form class="title-hab">
      Formation habilitante &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Non
      <kendo-switch name="switch-caces" [(ngModel)]="habilitation.formationHabilitante" (ngModelChange)="onChange()"></kendo-switch>
      Oui
    </form>
  </div>
  <div>
    <h5 class="uk-margin-remove uk-text-bold">AVIS D'HABILITATION</h5>
  </div>
  <div class="uk-grid uk-margin-bottom">
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Détail des opérations réalisées">
        <kendo-textbox
          [(ngModel)]="habilitation.detailOperations"
          (ngModelChange)="onChange()"
          [required]="true"
          style="width: 100%;">
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Nombre d'heures de pratique">
        <kendo-numerictextbox
          [(ngModel)]="habilitation.nbHeures"
          (ngModelChange)="onChange()"
          [min]="0"
          [required]="true"
          style="width: 100%;">
        </kendo-numerictextbox>
      </kendo-floatinglabel>
    </div>
    <div class="uk-width-1-4">
      <p class="uk-margin-remove">Résultat de l'avis</p>
      <kendo-dropdownlist 
          [data]="listItems" 
          [(ngModel)]="habilitation.resultat"
          (ngModelChange)="onChange()">
      </kendo-dropdownlist>
    </div>
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Autre proposition de titre">
        <kendo-textbox
          [(ngModel)]="habilitation.autreProposition"
          (ngModelChange)="onChange()"
          [required]="true"
          style="width: 100%;">
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>
  </div>
  <div>
    <h5 class="uk-margin-remove uk-text-bold">TITRE D'HABILITATION</h5>
  </div>
  <div class="uk-grid uk-margin-bottom">
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Affectation de l'apprenant">
        <kendo-textbox
          [(ngModel)]="habilitation.affectation"
          (ngModelChange)="onChange()"
          [required]="true"
          style="width: 100%;">
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Fonction de l'apprenant">
        <kendo-textbox
          [(ngModel)]="habilitation.fonction"
          (ngModelChange)="onChange()"
          [required]="true"
          style="width: 100%;">
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>
  </div>

  <div class="uk-card uk-card-default uk-margin-large-right">
    <div class="uk-card-header uk-padding-small uk-background-muted">
      <div class="uk-width-expand">
        <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
          SELECTION DES INDICES VALIDÉS
        </h3>
      </div>
    </div>
    <div class="uk-padding-remove">
      <kendo-panelbar
        [items]="listIndiceCategories"
        [expandMode]="expandMode"
        (stateChange)="getLineHabilitation($event)"
      >
        <ng-template kendoPanelBarItemTemplate>
          <table style="width: 100%">
            <tr>
              <th width="5%"></th>
              <th width="10%">PERSONNEL</th>
              <th width="15%">INDICE / ATTRIBUT</th>
              <th width="20%">DOMAINE DE TENSION</th>
              <th width="20%">OUVRAGES / INSTALLATION CONCERNÉES</th>
              <th width="20%">INDICATIONS SUPPLÉMENTAIRES</th>
              <th width="5%">THEO.</th>
              <th width="5%">PRAT.</th>
            </tr>
            <tr *ngFor="let hab of listCurrentLineHab" class="uk-margin" style="font-size: 16px">
              <td style="padding-top: 8px; text-align: center;">
                <input type="checkbox" class="checkbox" [(ngModel)]="hab.selectionne" (ngModelChange)="onChange()" />
              </td>
              <td class="uk-text-center"><a href="">Réinitialiser</a></td>
              <td class="uk-text-center">{{ getIndiceLibelle(hab) }}</td>
              <td class="uk-text-center">
                <div>
                  <kendo-dropdownlist
                    [data]="listDomaineTension"
                    textField="libelle"
                    valueField="id"
                    [(ngModel)]="hab.domaineTensionItem"
                    (ngModelChange)="onChange()"
                  ></kendo-dropdownlist>
                </div>
              </td>
              <td class="uk-text-center">
                <div>
                  <kendo-dropdownlist
                    [data]="listOuvrageInstallation"
                    textField="libelle"
                    valueField="id"
                    [(ngModel)]="hab.ouvrageItem"
                    (ngModelChange)="onChange()"
                  ></kendo-dropdownlist>
                </div>
              </td>
              <td class="uk-text-center">
                <kendo-textbox
                  [(ngModel)]="hab.indications"
                  (ngModelChange)="onChange()"
                  [required]="true"
                  style="width: 90%; padding: 0px;">
                </kendo-textbox>
              </td>
              <td style="padding-top: 8px; text-align: center;">
                <input type="checkbox" class="checkbox" [(ngModel)]="hab.theorique" (ngModelChange)="onChange()" />
              </td>
              <td style="padding-top: 8px; text-align: center;">
                <input type="checkbox" class="checkbox" [(ngModel)]="hab.pratique" (ngModelChange)="onChange()" />
              </td>
            </tr>
          </table>
        </ng-template>
      </kendo-panelbar>
    </div>
  </div>
  <div class="uk-grid margin-top">
    <form>
      Documents supplémentaires &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Non
      <kendo-switch name="switch-caces" [(ngModel)]="habilitation.documentsSupplementaires" (ngModelChange)="onChange()"></kendo-switch>
      Oui
    </form>
  </div>
  <div class="uk-grid uk-margin-remove-top">
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Autorisations spéciales">
        <kendo-textbox
          [(ngModel)]="habilitation.autorisationsSpeciales"
          (ngModelChange)="onChange()"
          [required]="true"
          style="width: 100%;">
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>
    <div class="uk-width-1-4">
      <kendo-floatinglabel text="Interdictions spéciales">
        <kendo-textbox
          [(ngModel)]="habilitation.interdictionsSpeciales"
          (ngModelChange)="onChange()"
          [required]="true"
          style="width: 100%;">
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>
    <div class="uk-width-1-4">
      <label>Date de délivrance</label>
      <div>
        <kendo-datepicker 
          [format]="'dd/MM/yyyy'" 
          [(ngModel)]="habilitation.dateDelivrance"
          (ngModelChange)="onChange()">
        </kendo-datepicker>
      </div>
    </div>
    <div class="uk-width-1-4">
      <label>Date de fin de validité</label>
      <div>
        <kendo-datepicker 
          [format]="'dd/MM/yyyy'" 
          [(ngModel)]="habilitation.dateFinValidite"
          (ngModelChange)="onChange()">
        </kendo-datepicker>
      </div>
    </div>
  </div>
  <!-- Le bouton de sauvegarde est supprimé puisque la sauvegarde est automatique -->
</div>
